export enum UpdatedAtStatus {
  Any,
  Today,
  LastWeek,
  LastMonth,
  LastYear
}
